import React from 'react';
import OfferCard from './OfferCard';
import styled from 'styled-components';

const ProductOfferSection = () => {
  const offers = [
    {
      icon: 'FaTruck',
      title: 'Flexible Delivery Models',
      description: 'A mix of On-site, Off-site, and Offshore models ensures quality solutions delivered on time and at optimal cost.',
    },
    {
      icon: 'FaHandshake',
      title: 'Risk/Reward Engagement',
      description: 'Customer-driven engagement model reduces Total Cost of Ownership (TCO) and enhances PLM implementation effectiveness.',
    },
    {
      icon: 'FaUsers',
      title: 'Agile Resourcing',
      description: 'Scalable, on-demand resources with the right expertise, available in dedicated or shared modes.',
    },
    {
      icon: 'FaDollarSign',
      title: 'Optimal Pricing',
      description: 'Balanced pricing model that aligns with customer expectations for Quality, Timeliness, and Price.',
    },
    {
      icon: 'FaGlobe',
      title: 'Global Value Delivery',
      description: 'Methodology for delivering PLM/CAD/CAM/CAE solutions that meet customer requirements with high quality and punctuality.',
    },
    {
      icon: 'FaCogs',
      title: 'Technology and Expertise',
      description: 'Best-in-class technology exploration and in-depth domain expertise ensure the delivery of solutions that maximize ROI.',
    },
  ];

  return (
    <Section>
      <Container>
        <SectionTitle>Our Core <span>Values</span></SectionTitle>
        <SectionSubtitle>
          We are committed to delivering quality services to our customers. Our core values are:
        </SectionSubtitle>
        <OfferCards>
          {offers.map((offer, index) => (
            <OfferCard
              key={index}
              icon={offer.icon}
              title={offer.title}
              description={offer.description}
            />
          ))}
        </OfferCards>
      </Container>
    </Section>
  );
}

export default ProductOfferSection;

const Section = styled.section`
  padding: 60px 20px;
  background-color: #062c3f;
  text-align: center;
`;

const Container = styled.div`
  max-width: 1140px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 3.1em;
   font-family: "Poppins", system-ui;
  color: #00cbf1;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: left;
  position: relative;

  span {
    color: #f0faff;
  }

 

  @media (max-width: 768px) {
    font-size: 2.2em;
  }

  @media (max-width: 480px) {
    font-size: 2em;
    text-align: left;
  }
`;

const SectionSubtitle = styled.p`
  font-family: "Poppins", system-ui;
  font-size: 1.2em;
  color: #f0faff;
  line-height: 1.6;
  margin-bottom: 40px;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 1em;
  }

  @media (max-width: 480px) {
    text-align: left;
    font-size: 0.9em;
  }
`;

const OfferCards = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
`;

